import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';

export const routes: Routes = [

  {
    path: '',
    loadComponent: () => import('./layouts/welcome-page/welcome-page').then((m) => m.WelcomePage),
  },
  {
    path: 'login',
    loadComponent: () => import('./layouts/login-page/login-page').then((m) => m.LoginPage),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./layouts/auth-flow/forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/admin-layout/admin-layout').then((m) => m.AdminLayout),
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./layouts/admin-layout/home-page/home-page').then((m) => m.HomePage),
      },
      {
        path: 'category-setup',
        loadComponent: () => import('./layouts/admin-layout/category-setup/category-setup').then(m => m.CategorySetup)
      },
      {
        path: 'category-setup/category-add',
        loadComponent: () => import('./layouts/admin-layout/category-setup/category-add/category-add').then(m => m.CategoryAdd)
      },
      {
        path: 'category-setup/category-edit/:id',
        loadComponent: () => import('./layouts/admin-layout/category-setup/category-add/category-add').then(m => m.CategoryAdd)
      },
      {
        path: 'category-setup/:id',
        loadComponent: () => import('./layouts/admin-layout/category-setup/category-view/category-view').then(m => m.CategoryView)
      },
      {
        path: 'idle-display',
        loadComponent: () => import('./layouts/admin-layout/idle-display/idle-display').then(m => m.IdleDisplay)
      },
      {
        path: 'medical-equipments',
        loadComponent: () =>
          import('./layouts/admin-layout/medical-equipments/medical-equipments').then(
            (m) => m.MedicalEquipments,
          ),
      },
      {
        path: 'medical-equipments/add-tool',
        loadComponent: () =>
          import('./layouts/admin-layout/medical-equipments/add-tool/add-tool').then(
            (m) => m.AddTool,
          ),
      },
      {
        path: 'medical-equipments/edit-tool/:id',
        loadComponent: () =>
          import('./layouts/admin-layout/medical-equipments/add-tool/add-tool').then(
            (m) => m.AddTool,
          ),
      },
      {
        path: 'medical-equipments/view-tool/:id',
        loadComponent: () =>
          import('./layouts/admin-layout/medical-equipments/add-tool/add-tool').then(
            (m) => m.AddTool,
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./layouts/admin-layout/users/users').then(
            (m) => m.Users,
          ),
      },
            {
        path: 'archive',
        loadComponent: () =>
          import('./layouts/admin-layout/archive/archive').then(
            (m) => m.Archive,
          ),
      },
    ],
  },
  {
    path: 'exhibits',
    loadComponent: () => import('./layouts/exhibit-user-layout/exhibit-user-layout').then((m) =>m.ExhibitUserLayout ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./layouts/exhibit-user-layout/exhibit-bg/exhibit-bg').then((m) => m.ExhibitBg),
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            loadComponent: () =>
              import('./layouts/exhibit-user-layout/exhibit-bg/exhibit-home/exhibit-home').then(
                (m) => m.ExhibitHome,
              ),
          },
          {
            path: 'category/:id',
            loadComponent: () =>
              import('./layouts/exhibit-user-layout/exhibit-bg/explore-category/explore-category').then(
                (m) => m.ExploreCategory,
              ),
          },
          {
            path: 'tool/:id',
            loadComponent: () =>
              import('./layouts/exhibit-user-layout/exhibit-bg/tool-detail/tool-detail').then(
                (m) => m.ToolDetail,
              ),
          },
          {
            path: 'tool/:id/timeline',
            loadComponent: () =>
              import('./layouts/exhibit-user-layout/exhibit-bg/tool-timeline/tool-timeline').then(
                (m) => m.ToolTimeline,
              ),
          },
        ],
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'welcome',
  },
];
